/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';
import { classNames } from '../utils/UNSAFE_classNames';
import { multiVariantStyles, styles } from './themes/InsetStyles.css';

type InsetProps = {
  children: ComponentChildren;

  /**
   * Inset variants for each existing use case.
   */
  variant?: 'listview' | 'toolbar';
};

export function Inset({ children, variant }: InsetProps) {
  const variantClasses = multiVariantStyles({
    variantGroup: variant
  });
  const classes = classNames([variantClasses, styles.insetBase]);

  return <div class={classes}>{children}</div>;
}
